// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class ShowView extends JQueryView {
  usage = '';
  fromInvestors: boolean;

  constructor(fromInvestors: boolean) {
    super('.simple_form');
    this.fromInvestors = fromInvestors;

    if (this.fromInvestors) {
      this.usage = 'capital';
      this.renderInvestorArea();
    } else {
      this.usage = 'company';
      this.renderAccountArea();
    }
  }

  @on({ event: 'click', selector: '.company' })
  onClickCompany() {
    this.usage = 'company';
    this.renderAccountArea();
  }

  @on({ event: 'click', selector: '.for-investors, .back-button' })
  onClickForInvestors() {
    this.usage = '';
    this.renderAccountArea();
  }

  @on({ event: 'click', selector: '.submit-button' })
  onClickSubmitButton() {
    if ($('.for-investors').hasClass('active')) {
      this.usage = 'capital';
      this.renderInvestorArea();
    }
  }

  @on({ event: 'click', selector: '.capital' })
  onClickCapital() {
    this.usage = 'capital';
    this.renderInvestorArea();
  }

  @on({ event: 'click', selector: '.investor' })
  onClickInvestor() {
    this.usage = 'investor';
    this.renderInvestorArea();
  }

  renderAccountArea() {
    $('#account-types').show();
    $('#investor-types, .back-button').hide();
    $('.title').text('どちらのアカウントで始めますか？');
    $('#user_recent_usage').val(this.usage);
    if (this.usage) {
      $('.submit-button').removeAttr('onclick', 'return false');
      $('.company').addClass('active');
      $('.for-investors').removeClass('active');
    } else {
      $('.submit-button').attr('onclick', 'return false');
      $('.company').removeClass('active');
      $('.for-investors').addClass('active');
    }
  }

  renderInvestorArea() {
    $('#account-types').hide();
    $('#investor-types, .back-button').show();
    $('.submit-button').removeAttr('onclick', 'return false');
    $('.title').text('利用する投資家アカウントを選択してください');
    $('#user_recent_usage').val(this.usage);
    $('.for-investors').removeClass('active');
    if (this.usage === 'capital') {
      $('.capital').addClass('active');
      $('.investor').removeClass('active');
    } else {
      $('.capital').removeClass('active');
      $('.investor').addClass('active');
    }
  }
}
